import React, {useEffect, useState} from "react";
import {isNotificationFormValid} from "./NotificationFormValidator";
import useAppContext from "../../../hooks/useAppContext";
import {Modal} from "antd";
import useUserContext from "../../../hooks/useUserContext";
import {MessageTemplateProps} from "../../../types/MessageTemplateProps";
import MessageEditFlow from "../../messageEditFlow/MessageEditFlow";
import {DEFAULT_FORM_VALUES, FormValuesProps} from "./NewNotificationModal";

import {ToastSkin} from "../../../context/ToastContext";
import useToast from "../../../hooks/useToast";

interface EditNotificationModalProps {
    editedNotification: MessageTemplateProps;
    onClose: () => void;
    flowId: number;
    flowTriggerId: number;
}


const EditNotificationModal = ({
    editedNotification,
    onClose,
    flowId,
    flowTriggerId,
}: EditNotificationModalProps) => {
    const [formValues, setFormValues] = useState<FormValuesProps>(DEFAULT_FORM_VALUES);
    const [formErrors, setFormErrors] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const { data: { flows }, actions: { editNotification, deleteNotification, removeTemplate, loadTemplates, loadFlows } } = useAppContext();
    const { selectedDomain } = useUserContext();
    const { showToast } = useToast();
    const onCloseModal = () => {
        setIsLoading(false);
        onClose();
    }

    useEffect(() => {
        if(!editedNotification) {
            setFormValues(DEFAULT_FORM_VALUES);
            onClose();
            return;
        }

        const initialValues: FormValuesProps = {
            title: editedNotification?.title,
            language: editedNotification?.language,
            content: editedNotification?.content,
            isCoupon: editedNotification.isCoupon,
            isWithImage: editedNotification.withImage,
            triggerDelay: editedNotification?.triggerDelay/60,
            isActive: editedNotification.active,
            distribution: editedNotification.distributionPercent,
            requiresConsent: editedNotification.requiresConsent,
            button1Text: editedNotification.button1Text,
            button2Text: editedNotification.button2Text,
        };

        setFormValues(initialValues);
    }, [editedNotification])

    const onEditNotification = async () => {
        setIsLoading(true);
        const errors = isNotificationFormValid(formValues, flowTriggerId);
        if(selectedDomain && !errors.length) {
            try {
                const response = await editNotification(selectedDomain, editedNotification.id, flowId, formValues);
                setIsLoading(false);
                // loadTemplates();
                loadFlows();
                showToast({ skin: ToastSkin.approval, text: 'Your message has been successfully updated'});
                onClose();
                return true;
            } catch (error) {
                showToast({ skin: ToastSkin.error, text: 'An unknown error occurred while saving your template'});
            }
        } else {
            showToast({ skin: ToastSkin.error, text: errors?.length ? errors[0] : 'An unknown error occurred while saving your template'});
        }
        setIsLoading(false);
        return false;
    }

    const onDeleteNotification = async () => {
        setIsLoading(true);
        if(selectedDomain) {
            const response = await deleteNotification(selectedDomain, flowId, editedNotification.id);
            onCloseModal();
            if(response.status === 200) {
                removeTemplate(editedNotification.id);
                showToast({ skin: ToastSkin.approval, text: 'Your message has been removed successfully'});
                setIsLoading(false);
                return true;
            } else {
                showToast({ text: 'An unknown error occurred while removing your template'});
                setIsLoading(false);
                return false;
            }
        }
        setIsLoading(false);
        return false;
    }

    const onFormUpdate = (newFormValues: any) => {
        !formErrors.length && setFormErrors([]);
        setFormValues(newFormValues);
    }

    return (
        <Modal
            // title={editedNotification?.title || "Edit Notification"}
            open={!!editedNotification}
            onOk={onEditNotification}
            onCancel={onCloseModal}
            confirmLoading={isLoading}
            okButtonProps={{ style: { display: 'none' }}}
            cancelButtonProps={{ style: { display: 'none' }}}
            width={1024}
            destroyOnHidden={true}
            centered={false}
        >
            {/*<EditNotificationForm initialValues={editedNotification} onFormUpdate={onFormUpdate} formErrors={formErrors} isLoading={isLoading} onDelete={onDeleteNotification} />*/}
            <MessageEditFlow flowId={flowId} messageId={editedNotification.id} formValues={formValues} setFormValues={onFormUpdate} isLoading={isLoading} onEdit={onEditNotification} onDelete={onDeleteNotification} onClose={onClose} flowTriggerId={flowTriggerId} />
        </Modal>
    );
}

export default EditNotificationModal;